import React, { useState, useCallback } from 'react';
import StickerViewer from '../components/sticker/stickerViewer.js';
import StickerSelection from '../components/sticker/stickerSelection.js';
import JsBarcode from 'jsbarcode';

export default function StickerPage() {
    const [lastUpdatedSticker, setLastUpdatedSticker] = useState(null);

    // ADD THIS: State for selected sticker index (0-based)
    const [selectedStickerIdx, setSelectedStickerIdx] = useState(null);

    const [stickers, setStickers] = useState(
        Array.from({ length: 27 }, () => ({
            Product: '',
            Barcode: '',
            EAN: ''
        }))
    );

    // Callback to be passed to stickerSelection to update lastUpdatedBrand
    const handleStickerUpdate = useCallback((stickerPosition) => {
        setLastUpdatedSticker(stickerPosition);
    }, []);

    const handleStickerData = (idx, arranged) => {
        const barcodeSVG = arranged.EAN ? generateBarcodeSVG(arranged.EAN) : '';
        setStickers(prev => {
            const updated = [...prev];
            updated[idx] = {
                Product: arranged.ProductDescription, // Only description, no ProductCode
                Barcode: barcodeSVG, // SVG string
                EAN: arranged.EAN
            };
            return updated;
        });
    };

    function isValidEAN13(ean) {
        // EAN-13 must be 13 digits, all numeric, and pass the check digit
        if (!/^\d{13}$/.test(ean)) return false;
        // Validate check digit
        const digits = ean.split('').map(Number);
        let sum = 0;
        for (let i = 0; i < 12; i++) {
            sum += digits[i] * (i % 2 === 0 ? 1 : 3);
        }
        const check = (10 - (sum % 10)) % 10;
        return check === digits[12];
    }

    function generateBarcodeSVG(ean) {
        const svgNode = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        if (ean && !isValidEAN13(ean)) {
            // Not a valid EAN-13, use CODE128
            JsBarcode(svgNode, ean, {
                format: "CODE128",
                lineColor: "#000",
                width: 2,
                height: 25, // Reduced from 50 to 25 (50% reduction)
                displayValue: true,
                fontSize: 16
            });
        } else if (ean) {
            // Valid EAN-13
            JsBarcode(svgNode, ean, {
                format: "ean13",
                displayValue: true,
                width: 2,
                height: 25, // Reduced from 50 to 25 (50% reduction)
                fontSize: 16
            });
        }
        return svgNode.outerHTML;
    }

    return (
        <>
            <section className='mosaic mosaic-layout-2'>

                <div className="mosaic-block-2-1">
                    {/* Pass lastUpdatedSticker and setSelectedStickerIdx to stickerViewer */}
                    <StickerViewer
                        lastUpdatedSticker={lastUpdatedSticker}
                        selectedStickerIdx={selectedStickerIdx}
                        setSelectedStickerIdx={setSelectedStickerIdx}
                        stickers={stickers}
                    />
                </div>

                <div className="mosaic-block-2-2">
                    <div style={{ position: 'sticky', top: '10px', zIndex: '10' }}>
                        {/* Pass the selected sticker index (1-based) to StickerSelection */}
                        <StickerSelection
                            selectedStickerIdx={selectedStickerIdx !== null ? selectedStickerIdx + 1 : null}
                            onStickerData={handleStickerData}
                        />
                    </div>
                </div>

                <div className="mosaic-block-2-3">
                    <div className='card'>
                        <div className='card-inner'>
                            {/* This block seems empty, maybe for future use */}
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}